<template>
  <div>
    <v-snackbar
      v-if="notification"
      v-model="notification.show"
      :type="notification.type"
      :timeout="timeoutLength"
      top
      app
      :right="$vuetify.breakpoint.xsOnly"
      :color="notification.color"
      class="the-notification--snackbar"
    >
      {{ notification.message }}
      <v-btn icon @click="notification.show = false">
        <v-icon> clear </v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'TheNotification',
  computed: {
    ...mapState('application', ['notification']),

    timeoutLength() {
      const { message, timeout } = this.notification;

      if (message.length <= 150) return timeout;

      // @jordan 50 is somewhat arbitrary. It seemed like enough extra time when I read it.
      return timeout + (message.length - 150) * 50;
    },
  },
};
</script>

<style lang="css">
.the-notification--snackbar .v-snack__content {
  height: initial;
}
</style>
